<template>
    <div :class="{root:true, top: top, 'show-menu': show_menu}">
        <template v-if="top">
            <top-menu :show_menu='show_menu' :data='data' @show_menu='showMenu()' @close_menu='hideMenu()' v-if='!print && !embed && !hide'>
                <slot name='menu'></slot>
                <template #header>
                    <slot name="menu-header"></slot>
                </template>
            </top-menu>
            <div class='layout-content'>
                <slot name="content"></slot>
            </div>
        </template>
        <template v-else>        
            <left-menu :show_menu='show_menu' :data='data' @show_menu='showMenu()' @close_menu='hideMenu()' v-if='!print && !embed && !hide'>
                <slot name='menu'></slot>
            </left-menu>
            <div id='globalleftpanel'>
            </div>
            <div class='layout-content'>
                <slot name="content"></slot>
            </div>
        </template>
    </div>
</template>

<script>
import LeftMenu from '@root/course/left_menu.vue'
import TopMenu from '@root/course/top_menu.vue'

const search = location.search.substring(1).split('&').map(c => c.split('=')).filter(c => c[0] !== "").reduce((a, b) => { a[b[0]] = (b.length > 1 ? b[1] : true); return a; }, {});

window.addShowMenuCallback = (callback) => {
    if (!window.showMenuCallbacks) {
        window.showMenuCallbacks = [];
    }
    window.showMenuCallbacks.push(callback);
}

window.removeShowMenuCallback = (callback) => {
    if (!window.showMenuCallbacks) {
        return;
    }
    const index = window.showMenuCallbacks.indexOf(callback);
    if (index >= 0) {
        window.showMenuCallbacks.splice(index, 1);
    }
}
function invokeShowMenuCallbacks(value) {
    if (window.showMenuCallbacks) {
        for(let callback of window.showMenuCallbacks) {
            callback(value);
        }
    }
}

export default { 
    data() { 
        return {
            top: true,
            show_menu: window.show_menu !== false,
            embed: !!search.embed,
            print: !!search.print,
            show_legend: false,
            options: {},
        }        
    },
    props: ["data", "hide"],
    components: {
        LeftMenu, TopMenu,
    },
    computed: {
        isLocal() {
            return document.location.hostname=="localhost";
        },
    },
    created () {
    },
    mounted() {
        let self = this;
        window.showMenu = () => {
            self.showMenu();
        };
        window.hideMenu = () => {
            self.hideMenu();
        };        

    },
    methods: {
        showMenu() {
            console.log("showMenu", this.show_menu);
            window.show_menu = true;
            this.show_menu = true;
            invokeShowMenuCallbacks(true);
        },
        hideMenu() {
            console.log("hideMenu", this.show_menu);
            window.show_menu = false;
            this.show_menu = false;
            invokeShowMenuCallbacks(false);
        },
    }
}
</script>

<style lang="scss">
    @import "@root/common";
</style>

<style lang="scss" scoped>

.root {
    display: flex;
    flex-direction: row;
    flex: 1 1;
    width: 100%;
    height: 100%;    
        
    .layout-content {
        transform-origin: top right;
        margin-left: 0px;
        margin-right: 0px;
        transition: 0.1s;
        //max-width: 1920px;  - when enabled, hiding menu from course map leaves blank space to the right
        flex: 1 1;
        overflow: auto;
    }

    .left-menu {
        flex: 0;
        transition: width 1s;        
    }

    &.show-menu {
        .layout-content {    
        }
    }

    &.top {
        flex-direction: column;
    }
}

</style>